import type { ModuleDefinition } from '@em-cms/core';

export const moduleConfig = {
  id: 'analytics',
  name: 'آنالیز',
  description: 'آمار بازدید و رفتار کاربران وب‌سایت',
  version: '0.1.0',
  is_core: false,
  requires: [],
  tables: ['cms_page_views', 'cms_analytics_daily', 'cms_analytics_pages'],
};

export const analyticsModule: ModuleDefinition = {
  id: 'analytics',
  name: 'آنالیز',
  description: 'آمار بازدید و رفتار کاربران وب‌سایت',
  version: '0.1.0',
  icon: 'BarChart3',
  category: 'utility',
  dependencies: [],
  tables: ['cms_page_views', 'cms_analytics_daily', 'cms_analytics_pages'],
  adminRoutes: [
    {
      path: '/analytics',
      component: () => import('./admin/AnalyticsDashboardPage').then(m => ({ default: m.AnalyticsDashboardPage })),
      permission: 'analytics.read',
      label: 'داشبورد آنالیز',
      icon: 'BarChart3',
    },
  ],
};
